import {
  ADD_ONE_PRODUCT,
  INITIALIZE_CART,
  REMOVE_ONE_PRODUCT,
  REMOVE_ALL_PRODUCT,
  SET_AMOUNT_PRODUCT,
  ADD_TO_CART,
} from "../actions/cart";

const default_state = {};

const cart = (state = default_state, action) => {
  switch (action.type) {
    case ADD_ONE_PRODUCT: {
      const pos = state[action.customer.id].products.findIndex(
        (product) => product.upc === action.payload.upc
      );

      if (pos === -1) {
        state[action.customer.id].products.push(action.payload);
        if (action.unit) {
          state[action.customer.id].products[
            state[action.customer.id].products.length - 1
          ].unit_in_cart = 1;
        } else {
          state[action.customer.id].products[
            state[action.customer.id].products.length - 1
          ].case_in_cart = 1;
        }
      } else {
        if (action.unit) {
          state[action.customer.id].products[pos].unit_in_cart =
            state[action.customer.id].products[pos].unit_in_cart + 1;
        } else {
          state[action.customer.id].products[pos].case_in_cart =
            state[action.customer.id].products[pos].case_in_cart + 1;
        }
      }

      const sumPrice = action.unit
        ? action.payload.display_unit_price
        : action.payload.display_case_price;

      state[action.customer.id].total = Math.abs(
        state[action.customer.id].total + sumPrice
      );

      return { ...state };
    }
    case INITIALIZE_CART: {
      state[action.customer.id] = { products: [], total: 0 };

      return { ...state };
    }
    case REMOVE_ONE_PRODUCT: {
      const pos = state[action.customer.id].products.findIndex(
        (product) => product.upc === action.payload.upc
      );

      if (action.unit) {
        state[action.customer.id].products[pos].unit_in_cart =
          state[action.customer.id].products[pos].unit_in_cart - 1;
      } else {
        state[action.customer.id].products[pos].case_in_cart =
          state[action.customer.id].products[pos].case_in_cart - 1;
      }

      if (
        state[action.customer.id].products[pos].unit_in_cart === 0 &&
        state[action.customer.id].products[pos].case_in_cart === 0
      ) {
        state[action.customer.id].products.splice(pos, 1);
      }

      const subPrice = action.unit
        ? action.payload.display_unit_price
        : action.payload.display_case_price;

      state[action.customer.id].total = Math.abs(
        state[action.customer.id].total - subPrice
      );

      return { ...state };
    }
    case SET_AMOUNT_PRODUCT: {
      let pos = state[action.customer.id].products.findIndex(
        (product) => product.upc === action.payload.upc
      );

      const price = action.unit
        ? action.payload.display_unit_price
        : action.payload.display_case_price;

      if (pos !== -1) {
        const subAmount = action.unit
          ? state[action.customer.id].products[pos].unit_in_cart
          : state[action.customer.id].products[pos].case_in_cart;

        const subPrice = +(price * subAmount).toFixed(2);

        state[action.customer.id].total = Math.abs(
          state[action.customer.id].total - subPrice
        );
      }

      if (+action.amount > 0) {
        if (pos === -1) {
          state[action.customer.id].products.push(action.payload);
        }

        pos = state[action.customer.id].products.findIndex(
          (product) => product.upc === action.payload.upc
        );

        if (action.unit) {
          state[action.customer.id].products[pos].unit_in_cart = +action.amount;
        } else {
          state[action.customer.id].products[pos].case_in_cart = +action.amount;
        }
      } else {
        if (pos === -1) return { ...state };

        if (action.unit) {
          state[action.customer.id].products[pos].unit_in_cart = +action.amount;
        } else {
          state[action.customer.id].products[pos].case_in_cart = +action.amount;
        }

        if (
          state[action.customer.id].products[pos].unit_in_cart === 0 &&
          state[action.customer.id].products[pos].case_in_cart === 0
        ) {
          state[action.customer.id].products.splice(pos, 1);
        }
      }

      if (+action.amount > 0) {
        const sumPrice = +(price * +action.amount).toFixed(2);

        state[action.customer.id].total = Math.abs(
          state[action.customer.id].total + sumPrice
        );
      }

      return { ...state };
    }
    case REMOVE_ALL_PRODUCT: {
      const pos = state[action.customer.id].products.findIndex(
        (product) => product.upc === action.payload
      );
      const sumUnitProducts =
        state[action.customer.id].products[pos].unit_in_cart *
        state[action.customer.id].products[pos].display_unit_price;
      const sumCaseProducts =
        state[action.customer.id].products[pos].case_in_cart *
        state[action.customer.id].products[pos].display_case_price;

      state[action.customer.id].products[pos].unit_in_cart = 0;
      state[action.customer.id].products[pos].case_in_cart = 0;
      state[action.customer.id].products.splice(pos, 1);

      state[action.customer.id].total = Math.abs(
        state[action.customer.id].total - (sumUnitProducts + sumCaseProducts)
      );

      return { ...state };
    }
    case ADD_TO_CART: {
      let sumUnitsTotal = 0;
      let sumCasesTotal = 0;

      action.payload.forEach((item) => {
        const sumUnit = item.unit_in_cart
          ? item.unit_in_cart * item.display_unit_price
          : 0;
        const sumCase = item.case_in_cart
          ? item.case_in_cart * item.display_case_price
          : 0;

        sumUnitsTotal += sumUnit;
        sumCasesTotal += sumCase;
      });

      state[action.customer.id].products = action.payload;
      state[action.customer.id].total = +(
        sumUnitsTotal + sumCasesTotal
      ).toFixed(2);

      return { ...state };
    }
    default:
      return state;
  }
};

export default cart;
